import { useTheme } from "@mui/material/styles";
import { memo, useState } from "react";
import ReactEcharts from "echarts-for-react";
import {
  Box,
  Grid,
  Typography,
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Card,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Divider,
  Avatar,
  Button,
  CardContent,
  LinearProgress,
  OutlinedInput,
} from "@mui/material";
import { useEffect } from "react";
import { GetDataAPi } from "app/apiCall/Postapi";
import Autocomplete from "@mui/material/Autocomplete";
import { useNavigate } from "react-router-dom";
import starIcon from "../../../assests/raiting.svg";
import config from "app/apiStore";
const { host } = config;

const DoughnutChart = ({ height, color = [] }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const [selectedGym, setSelectedGym] = useState(null);
  const [gymIdSelect, setGymIdSelect] = useState("");
  const [reviewsData, setReviewData] = useState([]);
  const [optionsGym, setOptionGym] = useState([]);
  const [passData, setPassData] = useState([]);
  const [bookings, setBookings] = useState([]);
  const [topGym, setTopGym] = useState([]);

  const option = {
    legend: {
      show: true,
      itemGap: 20,
      icon: "circle",
      bottom: 0,
      textStyle: {
        fontSize: 13,
        color: theme.palette.text.secondary,
        fontFamily: theme.typography.fontFamily,
      },
    },
    tooltip: {
      show: false,
      trigger: "item",
      formatter: "{a} <br/>{b}: {c} ({d}%)",
    },
    xAxis: [{ axisLine: { show: false }, splitLine: { show: false } }],
    yAxis: [{ axisLine: { show: false }, splitLine: { show: false } }],
    label: {
      fontSize: 13,
      color: theme.palette.text.secondary,
      fontFamily: theme.typography.fontFamily,
    },
    series: [
      {
        name: "Traffic Rate",
        type: "pie",
        radius: ["45%", "72.55%"],
        center: ["50%", "50%"],
        avoidLabelOverlap: false,
        hoverOffset: 5,
        stillShowZeroSum: false,
        label: {
          show: false,
          position: "center",
        },
        data: passData?.map((a) => ({
          value: a.total_bookings,
          name: a.pass_name.toUpperCase(),
        })),
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: "rgba(0, 0, 0, 0.5)",
          },
          label: {
            show: true,
            formatter: "{b} \n{c} ({d}%)",
            fontFamily: theme.typography.fontFamily,
            color: theme.palette.text.primary,
            fontSize: 14,
          },
        },
      },
    ],
  };

  useEffect(() => {
    getReviews();
    getGymList();
  }, []);

  useEffect(() => {
    getPassRepord();
  }, [gymIdSelect]);

  useEffect(() => {
    getBookings();
    getTopGym();
  }, []);

  const getPassRepord = async () => {
    try {
      const res = await GetDataAPi(
        gymIdSelect
          ? `/get-allpasses-revenue?gymId=${gymIdSelect}`
          : "/get-allpasses-revenue"
      );

      const resData = res?.revenueData;

      const formatedData = resData?.map((a) => {
        let string = a?.pass_name;
        let result = string
          ?.split(" ")
          ?.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ");

        return {
          ...a,
          name: result,
        };

        //  {value:a.total_bookings, name:a.pass_name}
      });
      setPassData(formatedData);
    } catch (error) {
      console.log("error ==> for pass repord", error);
    }
  };

  const getGymList = () => {
    GetDataAPi("/verify/gymprofile").then((s) => {
      setOptionGym(s?.gymProfilesWithPercentage);
    });
  };

  const getReviews = async () => {
    try {
      const rr = await GetDataAPi("/get-overall-gym-rate");

      setReviewData(rr.ratings);
    } catch {
      console.log("error");
    }
  };

  const getBookings = async () => {
    try {
      const res = await GetDataAPi("/get-recent-booking");

      setBookings(
        res?.recentBookings.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        )
      );
    } catch (e) {
      console.log("Erro for Vendor Gym bookings", e);
    }
  };

  const getTotalPrice = (pd) => {
    const total = pd.reduce((acc, current) => acc + current.price, 0);

    return total;
  };
  const getTopGym = async () => {
    try {
      const res = await GetDataAPi("/get-topgym-revenue");

      setTopGym(res?.revenueData);
    } catch (e) {
      console.log("Erro for Vendor Gym bookings", e);
    }
  };

  const handleGymChange = (event, value) => {
    setSelectedGym(value);
    setGymIdSelect(value?._id);
  };

  return (
    <>
      <Box sx={{ p: 2 }} style={{ height: "fit-content" }}>
        <Grid container>
          <Grid item xs={12} md={4}>
            <Typography variant="h4" component="h1" gutterBottom>
              Pass Insights
            </Typography>
          </Grid>
          <Grid item xs={12} md={8}>
            <Box
              sx={{
                display: "flex",
                alignItems: "end",
                justifyContent: "space-around",
                marginLeft: "51px",
              }}
            >
              <Grid
                item
                md={6}
                xs={12}
                style={{ margin: "1px -211px 3px 4px" }}
              >
                <FormControl fullWidth>
                  <Autocomplete
                    options={optionsGym}
                    getOptionLabel={(option) =>
                      option?.gym_name
                        ? option.gym_name
                            .toLowerCase()
                            .replace(/\b\w/g, (c) => c.toUpperCase())
                        : "All"
                    }
                    value={selectedGym}
                    onChange={handleGymChange}
                    renderOption={(props, option) => (
                      <li
                        {...props}
                        key={option?._id}
                        style={{
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          textTransform: "capitalize",
                        }}
                      >
                        {option?.gym_name} :- {option?.city}
                      </li>
                    )}
                    sx={{ width: "100%", maxWidth: "600px", margin: "auto" }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Select or Search Gym"
                        variant="outlined"
                        InputProps={{
                          ...params.InputProps,
                          style: { padding: "8px 12px" },
                        }}
                      />
                    )}
                  />
                </FormControl>
              </Grid>
            </Box>
          </Grid>
        </Grid>

        <Grid container>
          <Grid item xs={12} md={6}>
            <Grid item xs={12} md={6}>
              <Card sx={{ p: 3, mt: 2, borderRadius: "10px", width: "450px" }}>
                <Typography variant="h6" gutterBottom>
                  Top Selling Pass
                </Typography>
                <Divider />
                <List sx={{ pt: 0 }}>
                  {passData.length > 0 &&
                    passData?.slice(0, 5)?.map((member, i) => (
                      <ListItem key={i}>
                        <ListItemAvatar>
                          <Avatar
                            sx={{ width: 40, height: 40 }}
                            alt={member.name}
                            src={
                              member.pass_icon
                                ? `${host}/${member.pass_icon}`
                                : "https://staging.tonicww.in/flexxd-node//pass_icon-1728302985002-38453141.svg"
                            }
                          />
                        </ListItemAvatar>
                        <ListItemText
                          primary={
                            <Typography
                              variant="body2"
                              sx={{
                                fontWeight: "bold",
                                textTransform: "capitalize",
                              }}
                            >
                              {member.pass_name}
                            </Typography>
                          }
                          secondary={
                            <Typography
                              variant="caption"
                              color="text.secondary"
                            >
                              {member.total_bookings}
                            </Typography>
                          }
                        />
                      </ListItem>
                    ))}
                  {passData.length === 0 && (
                    <Typography variant="body2" color="text.secondary">
                      No data yet.
                    </Typography>
                  )}
                </List>
                {/* <Button variant="outlined" size="small" sx={{ mt: 1 }}>
            View all
          </Button> */}
              </Card>
            </Grid>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box>
              <ReactEcharts
                style={{ height: height }}
                option={{ ...option, color: [...color] }}
              />
            </Box>
          </Grid>
        </Grid>

        <Grid container spacing={4}>
          <Grid item xs={7} margin={2}>
            <Card sx={{ p: 2, mt: 2, borderRadius: "10px" }}>
              <Typography variant="h6" gutterBottom>
                Recent Bookings
              </Typography>
              <Divider />
              <List sx={{ pt: 0 }}>
                {bookings?.map((booking, i) => (
                  <ListItem key={i}>
                    <ListItemAvatar>
                      <Avatar
                        sx={{ width: 40, height: 40 }}
                        alt={booking.confirm_email[0]}
                      />
                    </ListItemAvatar>
                    <ListItemText
                      primary={booking?.confirm_email}
                      secondary={
                        <Typography variant="caption" color="text.secondary">
                          {booking.createdAt.slice(0, 10)}
                        </Typography>
                      }
                    />
                    <ListItemText
                      align="right"
                      primary={
                        <Typography
                          variant="caption"
                          sx={{
                            fontWeight: "bold",
                            color: "orange",
                          }}
                        >
                          ${getTotalPrice(booking.passes)}
                        </Typography>
                      }
                    />
                  </ListItem>
                ))}
              </List>
              <Button
                variant="outlined"
                size="small"
                sx={{ mt: 1 }}
                onClick={() => navigate("/bookinglist")}
              >
                View all
              </Button>
            </Card>
          </Grid>

          <Grid item xs={4} margin={2}>
            <Card sx={{ p: 2, mt: 2, borderRadius: "10px" }}>
              <Typography variant="h6" gutterBottom>
                Top 10 Gyms Revenue
              </Typography>
              <Divider />
              <List sx={{ pt: 0 }}>
                {topGym?.map((booking, i) => (
                  <ListItem key={i}>
                    <ListItemAvatar>
                      <Avatar sx={{ width: 40, height: 40 }} />
                    </ListItemAvatar>
                    <ListItemText
                      primary={booking.gym_name}
                      sx={{ textTransform: "capitalize" }}
                      secondary={
                        <Typography
                          variant="caption"
                          color="text.secondary"
                          sx={{ textTransform: "capitalize" }}
                        >
                          {booking?.city}
                        </Typography>
                      }
                    />
                    <ListItemText
                      align="right"
                      primary={
                        <Typography
                          variant="caption"
                          sx={{
                            fontWeight: "bold",
                            color: "orange",
                          }}
                        >
                          ${booking?.totalVendorShare?.toFixed(2)}
                        </Typography>
                      }
                    />
                  </ListItem>
                ))}
              </List>
              {/* <Button variant="outlined" size="small" sx={{ mt: 1 }} onClick={()=>navigate('/bookings')}>
            View all
          </Button> */}
            </Card>
          </Grid>
        </Grid>
      </Box>

        <Grid item xs={12} md={8} sx={{ m: 2 }} style={{ height: "fit-content" }}>
        <Card sx={{ p: 2, mt: 2, borderRadius: "10px", width: 850 }}>
          <Typography variant="h6" gutterBottom>
            Top 10 Gym Reviews
          </Typography>
          <Divider />
          <List sx={{ pt: 0 }}>
            {reviewsData?.map((member, i) => (
              <ListItem key={i}>
                <ListItemAvatar>
                  <Avatar
                    sx={{ width: 40, height: 40 }}
                    alt={member.gymName[0]}
                  />
                </ListItemAvatar>

                <ListItemText
                  primary={
                    <Typography
                      variant="body2"
                      sx={{ fontWeight: "bold", textTransform: "capitalize" }}
                    >
                      {member.gymName}
                    </Typography>
                  }
                  secondary={
                    <Typography
                      variant="caption"
                      color="text.secondary"
                      textTransform="capitalize"
                    >
                      {member.city}
                    </Typography>
                  }
                />
                <ListItemText
                  primary={
                    <Typography
                      variant="body2"
                      sx={{
                        fontWeight: "bold",
                        position: "absolute",
                        right: 2,
                      }}
                    >
                      <img src={starIcon} />
                      {member?.averageOverAllrate} ({member?.totalRate})
                    </Typography>
                  }
                />
              </ListItem>
            ))}
          </List>
        </Card>
      </Grid>
    </>
  );
};

export default memo(DoughnutChart);
